import React, { Component } from "react";
import { connect } from "react-redux";
import { getGlobalScriptsForCustomer, loadCompetition } from "../actions/AuthActions";
import { loadLocale } from "../actions/LocaleAction";
import { trackSession } from "../actions/TrackingActions";
import { API_V2_URL } from "../util/Constants";
import "./ParentDiv.css";
import {
  initReactI18next,
  withTranslation,
} from "react-i18next";
import i18n from "i18next";
import FadeLoader from "react-spinners/FadeLoader";
// import { Helmet } from "react-helmet";
import { getGlobalCode, getUrlWord, injectGlobalCode } from "../util/helpers/Helpers";
import $ from "jquery";

class ParentDiv extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
    this.resizeContainer = this.resizeContainer.bind(this);
  }

  resizeContainer = () => {
    const comp = this.props.competition;
    const iw = window.innerWidth;

    let useStyle = false;
    let useStyleBg = '';

    if(comp.bgColor){
      document.getElementById('root').style.backgroundColor = comp.bgColor;
      document.getElementById('root').style.minHeight = '100vh';
    }
    if (comp.desktopBg && iw >= 1024) {
      // document.body.style.backgroundImage = `url(${comp.desktopBg.file})`;
      useStyle = true;
      useStyleBg = comp.desktopBg.file;
    } else if (comp.tabletBg && iw < 1024 && iw >= 450) {
      // document.body.style.backgroundImage = `url(${comp.tabletBg.file})`;
      useStyle = true;
      useStyleBg = comp.tabletBg.file;
    } else if (comp.mobileBg && iw < 450) {
      // document.body.style.backgroundImage = `url(${comp.mobileBg.file})`;
      useStyle = true;
      useStyleBg = comp.mobileBg.file;
    }

    // iphone/ipad background fix
    if (useStyle) {
      const styles = `
          body {
            background: url(${useStyleBg}) no-repeat center center fixed;
          }
          
          body:after{
            content:"";
            position:fixed; /* stretch a fixed position to the whole screen */
            top:0;
            height:100vh; /* fix for mobile browser address bar appearing disappearing */
            left:0;
            right:0;
            z-index:-1; /* needed to keep in the background */
            background: url(${useStyleBg}) center center;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
          }
        `;

      var styleSheet = document.createElement("style");
      styleSheet.innerText = styles;
      document.head.appendChild(styleSheet);
    }

    document.title = comp.name;
    window.setTimeout(() => {
      let elHeight = document.body.scrollHeight;
      if (window.self !== window.top) {
        window.parent.postMessage(`benchvoteResize-${elHeight}`, "*");
      }
    }, 500);
  };

  componentDidUpdate(prevProps) {
    if (this.props.competition.id && !prevProps.competition.id) {
      window.addEventListener("resize", this.resizeContainer);
      this.props.dispatch(
        trackSession(this.props.competition.id, this.props.dispatch)
      );
      this.resizeContainer();
    }
    if (this.props.tracking.flakeId && !prevProps.tracking.flakeId) {
      const { flakeId } = this.props.tracking;
      window.parent.postMessage(`benchvoteTracking-${flakeId}`, "*");
      window.parent.postMessage(
        `benchvoteTrackingApi-${encodeURI(API_V2_URL)}`,
        "*"
      );
      window.parent.postMessage(
        `benchvoteCompetition-${this.props.competition.id}`,
        "*"
      );
    }
    if (this.props.tracking.idVote && !prevProps.tracking.idVote) {
      const { idVote } = this.props.tracking;
      window.parent.postMessage(`benchvoteVote-${idVote}`, "*");
    }
    if (this.props.tracking.idOptin && !prevProps.tracking.idOptin) {
      const { idOptin } = this.props.tracking;
      window.parent.postMessage(`benchvoteOptin-${idOptin}`, "*");
    }
    //to load language
    if (this.props.competition.localeId && !prevProps.competition.localeId) {
      this.props.dispatch(
        loadLocale(this.props.competition.localeId, this.props.dispatch)
      );
    }
    if (
      this.props.locale.lang &&
      Object.keys(this.props.locale.lang).length !== 0 &&
      !prevProps.locale.lang.pick_now
    ) {
      setTimeout(()=>{
      this.setState({...this.state,loader:false})
    },500)
      i18n.use(initReactI18next).init({
        lang: this.props.competition.localeId,
        fallbackLng: this.props.competition.localeId,
        debug: true,
        ns: ["common"],
        defaultNS: "common",
        interpolation: {
          escapeValue: false // not needed for react as it escapes by default
        },
        resources: {
          [this.props.competition.localeId]: {
            common: this.props.locale.lang
          }
        }
      });
    }

    if (!prevProps.globalScript.globalScriptFetched && this.props.globalScript.globalScriptFetched) {
      console.log('propps-ok-new', this.props.globalScript.globalScriptData);
      let gsd = this.props.globalScript.globalScriptData;
      if (gsd && gsd != {}) {
        if (gsd.globalCodeForHeader && gsd.globalCodeForHeader != {}) {
          injectGlobalCode($, 'head', getGlobalCode(gsd.globalCodeForHeader));
        }
        if (gsd.globalCodeForBody && gsd.globalCodeForBody != {}) {
          injectGlobalCode($, 'body', getGlobalCode(gsd.globalCodeForBody));
        }
        if (gsd.globalCodeForFooter && gsd.globalCodeForFooter != {}) {
          injectGlobalCode($, 'footer', getGlobalCode(gsd.globalCodeForFooter));
        }
      }
    }
  }

  componentDidMount() {
    // let hash = this.props.location.hash;
    // hash = hash ? hash.replace(/(^#)/g, "") : "";
    let hash = getUrlWord(this.props.match.url, this.props.location.hash);

    if (hash) {
      this.props.dispatch(getGlobalScriptsForCustomer(hash, this.props.dispatch));
      this.props.dispatch(loadCompetition(hash, this.props.dispatch));
      this.setState({ hash });
      this.setState({...this.state,loader:true})
    }
    this.resizeContainer();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeContainer);
  }

  render() {
    const comp = this.props.competition;
    return ( <React.Fragment>
        {/* <Helmet>
        <meta property="og:type" content="website" />
        <meta property="og:title" content={comp.shareEnabled && comp.socialSharingTextTitle?comp.socialSharingTextTitle:comp.detail} />
        <meta property="og:image" content={comp.shareEnabled && comp.socialSharingBackgroundImageUrl?comp.socialSharingBackgroundImageUrl:(comp.logoBg && comp.logoBg.file)?comp.logoBg.file:''} />
        <meta content="image/*" property="og:image:type" />
        <meta property="og:url" content={comp.webapp+'#'+comp.hash} />
        <meta property="og:description" content={comp.shareEnabled && comp.socialSharingTextDescription?comp.socialSharingTextDescription:comp.description} />   
        </Helmet> */}
     { this.state.loader ?<div className={"loaderCss"}  >
        <div className={"loader"} ><FadeLoader  size={150}  color={"#ffffff"}   loading={this.state.loader}/></div>
      </div>:null }
    <div className={"main-cont"}>{this.props.children}</div>
  </React.Fragment>);
  }
}

//-------------------------------------------------------------------------
//-------------------- Mapping store to App's props ----------------------
//-------------------------------------------------------------------------

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    competition: state.default.bulldogs.competition,
    tracking: state.default.tracking,
    locale: state.default.locale,
    globalScript: state.default.bulldogs.globalScript
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ParentDiv));
